var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{style:(_vm.style),attrs:{"color":_vm.color,"permanent":"","clipped":_vm.clipped,"fixed":_vm.fixed,"width":_vm.width,"app":_vm.app}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }